/**
 * Shared form validation and UI messages
 */

export const FORM_MESSAGES = {
  // Validation messages
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_PHONE: 'Please enter a valid phone number',
  INVALID_NUMBER: 'Please enter a valid number',
  INVALID_POSITIVE_NUMBER: 'Please enter a positive number',
  
  // Selection messages
  SELECT_CATEGORY_FIRST: 'Please select a category first',
  NO_OPTIONS_AVAILABLE: 'No options available',
  
  // Loading messages
  LOADING: 'Loading...',
  
  // Error messages
  FAILED_TO_LOAD: 'Failed to load data',
  SOMETHING_WENT_WRONG: 'Something went wrong',
} as const

export const FORM_PLACEHOLDERS = {
  // Personal info
  LAST_NAME: 'Last name',
  FIRST_NAME: 'First name',
  MIDDLE_NAME: 'Middle name',
  MAIDEN_NAME_ALIAS: 'Maiden name/Alias',
  EMAIL: 'Email',
  PHONE_NUMBER: '000-000-0000',
  DATE_OF_BIRTH: 'YYYY/MM/DD',
  APPLICATION_NUMBER: 'Application number',
  UCI_NUMBER: 'UCI number',
  
  // Address
  SELECT_COUNTRY: 'Select your country',
  SELECT_CITIZENSHIP: 'Select citizenship',
  UNIT_APARTMENT: 'Enter unit/apartment',
  STREET_ADDRESS: 'Enter street number and name',
  CITY: 'Enter city',
  STATE_PROVINCE: 'Select state/province...',
  STATE_PROVINCE_TEXT: 'Enter state/province/region',
  ZIP_POSTAL_CODE: 'Enter zip/postal code',
  ZIP_POSTAL_CODE_CA: 'e.g. A1A 1A1',
  ZIP_POSTAL_CODE_US: 'e.g. 12345 or 12345-6789',
  
  // Payment
  ENTER_AMOUNT: 'Enter amount...',
  SELECT_PAYMENT_METHOD: 'Select payment method',
} as const

/** Date/datetime display format patterns (date-fns). Single source of truth for UI. */
export const DATE_DISPLAY_FORMAT = 'yyyy/MM/dd'
export const DATETIME_DISPLAY_FORMAT = 'yyyy/MM/dd HH:mm'
export const DATETIME_DISPLAY_FORMAT_WITH_SECONDS = 'yyyy/MM/dd HH:mm:ss'

export const FORM_LABELS = {
  // Personal info
  LAST_NAME: 'Last name',
  FIRST_NAME: 'First name',
  MIDDLE_NAME: 'Middle name',
  MAIDEN_NAME_ALIAS: 'Maiden name/Alias (if applicable)',
  GENDER: 'Gender',
  DATE_OF_BIRTH: 'Date of birth',
  CITIZENSHIP: 'Citizenship',
  EMAIL: 'Email',
  PHONE_NUMBER: 'Phone number',
  APPLICATION_NUMBER: 'Application number',
  UCI_NUMBER: 'UCI number',
  
  // Address
  COUNTRY: 'Country',
  UNIT_APARTMENT: 'Unit/Apartment (if applicable)',
  STREET_NUMBER_NAME: 'Street number & street name',
  CITY: 'City',
  STATE_PROVINCE_REGION: 'State/Province/Region',
  ZIP_POSTAL_CODE: 'Zip/Postal code',
  
  // Family
  MARITAL_STATUS: 'Marital Status',
  HAS_DEPENDENTS: 'Do you have dependents?',
  SAME_ADDRESS_AS_APPLICANT: 'Same Address as Applicant?',
  SAME_ADDRESS_AS_APPLICANT_SHORT: 'Same address as applicant',
  
  // Payment
  PAYMENT_DATE: 'Payment date',
  PAYMENT_METHOD: 'Payment method',
  MARK_AS_RECEIVED: 'Mark as Received',
  FIRST_PAYMENT: 'First payment',
  FINAL_PAYMENT: 'Final payment',
} as const

export const FORM_HEADINGS = {
  // Step headings
  CHOOSE_CATEGORY: 'Please choose the application category',
  CHOOSE_SERVICE_TYPE: 'Please choose the service type of immigration check',
  ENTER_PERSONAL_INFO: 'Please enter your personal information',
  PROVIDE_FAMILY_INFO: 'Please provide your family information',
  ENTER_CURRENT_ADDRESS: 'Please enter your current address details',
  PROVIDE_SPONSOR_INFO: "Please provide your sponsor's information (optional)",
  ENTER_CONTRACT_AMOUNT: 'Please enter total contract amount',
  
  // Section headings
  DEPENDENTS: 'Dependents',
  DEPENDENT_ADDRESS: "Dependent's Address",
  SPONSOR_ADDRESS: "Sponsor's Address",
} as const

export const FORM_BUTTONS = {
  ADD_DEPENDENT: 'Add Dependent',
  NEXT: 'Next',
  BACK: 'Back',
  CONFIRM: 'Confirm',
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  SAVE: 'Save',
} as const

export const YES_NO_OPTIONS = [
  { value: 'no', label: 'No' },
  { value: 'yes', label: 'Yes' },
] as const
